import type { CustomSpacing, FeatureGroupElementProps } from '@genially/public-web-components';

import type { BackgroundDTO } from 'core/infrastructure/parseBackground';
import type { FC } from 'react';
import { FeatureGroupDisplay } from '@genially/public-web-components';
import type { MediaIframeDTO } from 'core/domain/Media/MediaIframeDTO';
import type { MediaImageDTO } from 'core/domain/Media/MediaImageDTO';
import type { MediaVideoDTO } from 'core/domain/Media/MediaVideoDTO';
import { parseBackground } from 'core/infrastructure/parseBackground';
import { translate } from 'core/infrastructure/translator';

interface FeatureGroupProps {
  displayTitle: string;
  shortTitle: string;
  description: {
    value: string;
    format: string;
    processed: string;
  };
  icon: {
    name: string;
    color: string;
  };
  anchorID: string;
  link?: {
    url: {
      path: string;
    };
    title: string;
  };
  media?: MediaIframeDTO | MediaVideoDTO | MediaImageDTO;
  relatedFeatures: FeatureGroupElementProps[];
  featureBlocks: FeatureGroupElementProps[];
}
interface ParagraphFeatureGroupDisplayProps {
  behaviorSettings: {
    rowStyle: { background: BackgroundDTO; spacing: CustomSpacing };
  };
  fieldDisplayType: string;
  fieldFeatureGroupChoice: FeatureGroupProps[];
  langcode: {
    value: string;
  };
}

export const ParagraphFeatureGroupDisplay: FC<ParagraphFeatureGroupDisplayProps> = ({
  fieldFeatureGroupChoice,
  behaviorSettings,
  langcode,
}) => {
  const translateFromContent = (key: string) => translate(langcode ? langcode.value : 'en', key);
  const showAllFeatMobile = translateFromContent('featuregroup_viewmore_button');
  const hideAllFeatMobile = translateFromContent('featuregroup_viewless_button');
  const statusNewTag = translateFromContent('status_new_tag');
  const statusComingSoonTag = translateFromContent('status_coming_soon_tag');
  const literals = { showAllFeatMobile, hideAllFeatMobile, statusNewTag, statusComingSoonTag };
  const normalizedFeatureGroups = fieldFeatureGroupChoice?.map((item: any) => {
    const normalized = item?.entity ?? item;
    const relatedFeatures: any[] = [];
    normalized?.featureBlocks?.forEach((featureBlock: any) => {
      const features = featureBlock?.entity?.features ?? [];
      features.forEach((feature: any) => {
        relatedFeatures.push(feature?.entity ?? feature);
      });
    });
    return {
      ...normalized,
      relatedFeatures,
    };
  });

  return (
    <FeatureGroupDisplay
      featureGroup={normalizedFeatureGroups}
      background={parseBackground(behaviorSettings?.rowStyle?.background)}
      spacing={behaviorSettings?.rowStyle?.spacing}
      literals={literals}
    />
  );
};
